import styled from 'styled-components'

export const Container = styled.div`
  max-width: 1180px;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fafcff;
  margin: 0 auto;
  padding: 8px 24px 24px;
  gap: 10px;
  @media (max-width: 768px) {
    padding: 18px 18px 24px;
  }
`
export const Title = styled.h2`
  margin: 4px 0 0;
  font-size: clamp(32px, 3vw, 42px);
  line-height: 1.1;
  @media (max-width: 574px) {
    font-size: 22px;
    line-height: 32px;
  }
`
export const Paragraph = styled.p`
  color: #1f2124;
  font-size: 16px;
  line-height: 1.45;
  text-align: justify;
  width: 100%;
  margin: 0;
  @media (max-width: 574px) {
    font-size: 14px;
    line-height: 1.4;
  }
`
export const List = styled.ul`
  color: #1f2124;
  font-size: 16px;
  margin: 0;
  @media (max-width: 574px) {
    font-size: 2.5vw;
  }
`
export const CallToActionTestDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-top: 4px;
  padding-top: 12px;
  border-top: 1px solid #dfe8f3;
  @media (max-width: 574px) {
    width: 100%;
    align-self: center;
    flex-direction: column;
    gap: 12px;
    padding-top: 10px;
  }
`

export const LoaderContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  right: 50%;
  bottom: 50%;
`
